import React, { useState, useEffect } from "react";
import { colors, fonts } from "../utils/constants.js";
import { isMobile, getButtonStyle } from "../utils/responsive.js";

function GuestVoteSuccess({ 
  market, 
  vote, 
  onClose, 
  onSignUp, 
  onViewResults,
  isVisible = true 
}) {
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => setIsMobileDevice(isMobile());
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  useEffect(() => {
    if (isVisible) {
      // Auto-close after 8 seconds
      const timer = setTimeout(() => {
        handleClose();
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  if (!isVisible) return null;

  const voteEmoji = vote?.side === "YES" ? "✅" : "❌";
  const voteText = vote?.side === "YES" ? "ДА" : "НЕ";

  return (
    <div
      style={{
        position: "fixed",
        bottom: isMobileDevice ? 12 : 24,
        right: isMobileDevice ? 12 : 24,
        left: isMobileDevice ? 12 : "auto",
        background: colors.card,
        borderRadius: 12,
        padding: isMobileDevice ? 16 : 20,
        maxWidth: isMobileDevice ? "none" : 400,
        width: isMobileDevice ? "auto" : "400px",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
        border: `1px solid ${colors.border}`,
        zIndex: 1000,
        transform: isClosing ? "translateY(100%)" : "translateY(0)",
        opacity: isClosing ? 0 : 1,
        transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
      }}
    >
      {/* Close button */}
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          background: "transparent",
          border: "none",
          fontSize: 16,
          cursor: "pointer",
          color: colors.textTer,
          width: 24,
          height: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 4,
        }}
        onMouseEnter={(e) => {
          e.target.style.background = colors.hover;
        }}
        onMouseLeave={(e) => {
          e.target.style.background = "transparent";
        }}
      >
        ×
      </button>

      {/* Success Header */}
      <div style={{ marginBottom: 16 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 8,
            gap: 8,
          }}
        >
          <span style={{ fontSize: 24 }}>{voteEmoji}</span>
          <h3
            style={{
              margin: 0,
              fontSize: isMobileDevice ? 18 : 20,
              fontWeight: 600,
              color: colors.text,
            }}
          >
            Гласът е записан!
          </h3>
        </div>
        
        <p
          style={{
            margin: 0,
            fontSize: 14,
            color: colors.textSec,
            lineHeight: 1.5,
          }}
        >
          Гласувахте <strong>{voteText}</strong> за: "{market?.question?.substring(0, 80)}..."
        </p>
      </div>

      {/* Benefits */}
      <div
        style={{
          padding: 12,
          background: colors.greenBg,
          borderRadius: 8,
          border: `1px solid ${colors.greenBorder}`,
          marginBottom: 16,
        }}
      >
        <h4
          style={{
            margin: "0 0 8px 0",
            fontSize: 14,
            fontWeight: 600,
            color: colors.green,
          }}
        >
          🌟 Регистрирайте се за повече:
        </h4>
        <ul
          style={{
            margin: 0,
            paddingLeft: 16,
            fontSize: 13,
            color: colors.textSec,
            lineHeight: 1.4,
          }}
        >
          <li>История на всички ваши гласувания</li>
          <li>Персонални статистики и точност</li>
          <li>Участие в специални анкети</li>
          <li>Уведомления за нови въпроси</li>
        </ul>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          gap: 8,
          justifyContent: "space-between",
          flexDirection: isMobileDevice ? "column" : "row",
        }}
      >
        <button
          onClick={onViewResults}
          style={{
            ...getButtonStyle("secondary", "small", isMobileDevice),
            flex: 1,
            background: "transparent",
            color: colors.blue,
            border: `1px solid ${colors.blue}`,
            fontSize: 13,
          }}
          onMouseEnter={(e) => {
            e.target.style.background = colors.blueBg;
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
          }}
        >
          Виж резултати
        </button>
        <button
          onClick={onSignUp}
          style={{
            ...getButtonStyle("primary", "small", isMobileDevice),
            flex: 1,
            background: colors.green,
            color: "#FFF",
            border: "none",
            fontSize: 13,
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "#059669";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = colors.green;
          }}
        >
          Регистрация
        </button>
      </div>

      {/* Progress indicator */}
      <div
        style={{
          marginTop: 12,
          height: 2,
          background: colors.border,
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            background: colors.green,
            width: "100%",
            animation: "shrink 8s linear forwards",
          }}
        />
      </div>

      <style jsx>{`
        @keyframes shrink {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
}

export default GuestVoteSuccess;